import script from "./compoundQueryPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./compoundQueryPlan.vue?vue&type=script&setup=true&lang=js"

import "./compoundQueryPlan.vue?vue&type=style&index=0&id=53bad64c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53bad64c"]])

export default __exports__